import { Component, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Observable } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';
import { HttpClient } from '@angular/common/http';
import { catchError, of } from 'rxjs';
import { RouterLink } from '@angular/router';

import { LogIn } from '../../../store/actions/auth.actions';
import { selectAuthErrorMessage, seelectIsLoading } from '../../../store/selectors/auth.selectors';
import { environment } from '../../../../environments/environments';

@Component({
  selector: 'app-login',
  imports: [CommonModule, FormsModule],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {
  private store = inject(Store);
  private router = inject(Router);
  private http = inject(HttpClient);

  isLoading = toSignal(this.store.select(seelectIsLoading));
  errorMessage$: Observable<string | null> = this.store.select(selectAuthErrorMessage);

  user = {
    email: '',
    password: ''
  };

  showForgotPassword = false;
  resetEmail = '';
  isResetting = false;
  successMessage = '';

  onSubmit() {
    if (this.user.email && this.user.password) {
      this.store.dispatch(LogIn({
        email: this.user.email,
        password: this.user.password
      }));
    }
  }

  toggleForgotPassword() {
    this.showForgotPassword = !this.showForgotPassword;
    this.successMessage = '';
    this.resetEmail = '';
  }

  goToRegister() {
    this.router.navigate(['/auth/register']);
  }

  onForgotPassword() {
    if (!this.resetEmail) {
      return;
    }

    this.isResetting = true;
    this.successMessage = '';

    const apiUrl = environment.apiUrl + 'api/auth/forgot-password';

    this.http.post(apiUrl, { email: this.resetEmail }).pipe(
      catchError(error => {
        console.error('Forgot password error:', error);
        return of({
          error: error.error?.error || 'Failed to send password reset email'
        });
      })
    ).subscribe({
      next: (response: any) => {
        this.isResetting = false;

        if (response.error) {
          console.error('Password reset error:', response.error);
        } else {
          this.successMessage = 'Si votre email existe dans notre système, vous recevrez un lien de réinitialisation.';
          this.resetEmail = '';

          setTimeout(() => {
            this.showForgotPassword = false;
            this.successMessage = '';
          }, 5000);
        }
      },
      error: (error) => {
        this.isResetting = false;
        console.error('Network error:', error);
      }
    });
  }
}